export default "__VITE_ASSET__0kyoJTiK__"